import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setStatusOption } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';

function SetStatus() {
  const dispatch = useDispatch();
  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.clientsFilter
  );

  function setMyStatus(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setStatusOption(value));
  }

  return (
    <Wrapper.Default isActive flexDirection="row">
      <span>Status:</span>
      <Form.Control
        as="select"
        style={{ width: '11rem', margin: '0 1rem 0 0.25rem' }}
        value={clientsFilterState.status}
        onChange={(event) => setMyStatus(event)}>
        <option key={0} value="todos">
          Todos
        </option>
        <option key={1} value={1}>
          1 - Aprovada/Ativa
        </option>
        <option key={2} value={2}>
          2 - Pendente
        </option>
        <option key={3} value={3}>
          3 - Recusada
        </option>
        <option key={4} value={4}>
          4 - Bloqueada
        </option>
        <option key={5} value={5}>
          5 - Encerrada e os demais status
        </option>
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetStatus;
